import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const AccrualDraftBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { close } = useCommands();
    const {
        selectedAccrualDraftCount = 0,
        onAccrualDraftBulkConfirm,
        accrualDraftBulkConfirmLabel = "Confirm",
        onAccrualDraftBulkDiscard,
        onAccrualDraftBulkRerun,
        onAccrualDraftBulkMove,
        accrualDraftBulkMoveLabel = "Move",
        onAccrualDraftBulkConfirmCounterparties,
        accrualDraftCounterpartyLabel = "vendors",
    } = options;

    return (
        <Command.Group heading={`${selectedAccrualDraftCount} selected`}>
            {onAccrualDraftBulkConfirm && (
                <CommandItem
                    keywords={["confirm", "import", "bill", "invoice"]}
                    onSelect={() => {
                        close();
                        onAccrualDraftBulkConfirm();
                    }}
                >
                    {accrualDraftBulkConfirmLabel}
                </CommandItem>
            )}
            {onAccrualDraftBulkConfirmCounterparties && (
                <CommandItem
                    keywords={["confirm", "vendor", "customer", "counterparty"]}
                    onSelect={() => {
                        close();
                        onAccrualDraftBulkConfirmCounterparties();
                    }}
                >
                    {`Confirm ${accrualDraftCounterpartyLabel}`}
                </CommandItem>
            )}
            {onAccrualDraftBulkRerun && (
                <CommandItem
                    keywords={["rerun", "extract", "extraction"]}
                    onSelect={() => {
                        close();
                        onAccrualDraftBulkRerun();
                    }}
                >
                    Rerun extraction
                </CommandItem>
            )}
            {onAccrualDraftBulkMove && (
                <CommandItem
                    keywords={["move", "invoice", "bill"]}
                    onSelect={() => {
                        close();
                        onAccrualDraftBulkMove();
                    }}
                >
                    {accrualDraftBulkMoveLabel}
                </CommandItem>
            )}
            {onAccrualDraftBulkDiscard && (
                <CommandItem
                    keywords={["discard", "delete", "remove"]}
                    onSelect={() => {
                        close();
                        onAccrualDraftBulkDiscard();
                    }}
                >
                    Discard
                </CommandItem>
            )}
        </Command.Group>
    );
};
